import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const WingateWiki: React.FC = () => {
  useEffect(() => {
    // Set page title
    document.title = 'Historic Wingate Track - Wingipedia';
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'The Historic Wingate Track is the central facility of WINGO World, located in Brooklyn and named after George Wood Wingate.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Full-width header section */}
      <div className="w-full bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4 lg:ml-36">
        {/* Mobile header and intro - appears first on mobile */}
        <div className="lg:hidden mb-6">
          {/* Wikipedia-style header */}
          <div className="border-b border-gray-200 pb-2 mb-4">
              <h1 className="text-3xl sm:text-4xl font-semibold mb-2 border-b border-gray-300 pb-1" style={{ fontFamily: 'Hoefler Text, Garamond, Times New Roman, serif', letterSpacing: '-0.02em' }}>
                Historic Wingate Track
            </h1>
              <p className="text-sm text-gray-600 italic mb-2">From Wingipedia, the WINGO World encyclopedia</p>
          </div>

          {/* Lead section */}
          <div className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
            <p className="text-base mb-3">
                The <strong>Historic Wingate Track</strong> is a public 320-meter track located in Brooklyn, New York, and the primary physical site of WINGO World. Named after George Wood Wingate, the track functions as a municipal athletic facility and as the sole location where WINGO can be mined.
              </p>
            <p className="text-base mb-3">
                All WINGO issuance is tied to verified 320-meter segments completed on the track <a href="https://www.strava.com/segments/39307521" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://www.strava.com/segments/39307521</a>. These activities are recorded on the Wingo World ledger <Link to="/" className="text-blue-600 hover:underline">wingo320.com</Link> and overseen by <Link to="/wingipedia/daisy" className="text-blue-600 hover:underline">Coach DAISY™</Link> of the 320 Track Club.
              </p>
            </div>
          </div>

        {/* Desktop header and intro */}
        <div className="hidden lg:block mb-6">
          {/* Wikipedia-style header */}
          <div className="border-b border-gray-200 pb-2 mb-4">
            <h1 className="text-3xl sm:text-4xl font-semibold mb-2 border-b border-gray-300 pb-1" style={{ fontFamily: 'Hoefler Text, Garamond, Times New Roman, serif', letterSpacing: '-0.02em' }}>
              Historic Wingate Track
            </h1>
            <p className="text-sm text-gray-600 italic mb-2">From Wingipedia, the free encyclopedia</p>
          </div>

          {/* Desktop bio image - positioned to float right */}
          <div className="hidden lg:block float-right ml-6 mb-6 w-80" style={{ fontFamily: 'Georgia, serif' }}>
            <div className="bg-white border border-gray-300 p-3 text-xs" style={{ fontSize: '11px', lineHeight: '1.3' }}>
              <div className="text-center mb-2">
                <span className="font-bold" style={{ fontSize: '14px' }}>Historic Wingate Track</span>
              </div>
              
              <div className="text-center mb-2">
                <img 
                  src="/wingate1.jpg" 
                  alt="Historic Wingate Track" 
                  className="w-full h-56 object-cover rounded"
                  style={{ objectPosition: 'center' }}
                />
              </div>
              
              <div className="space-y-0.5">
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Location:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>Brooklyn, NY</span>
                </div>
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Named for:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>George Wood Wingate</span>
                </div>
          
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Opened:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>1957<sup><a href="#ref-1" className="text-blue-600 hover:underline" title="Official opening">*</a></sup></span>
                </div>
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Tenants:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>Brooklyn; 320 Track Club</span>
                </div>
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Overseer:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>Coach DAISY™</span>
                </div>
              </div>
            </div>
          </div>

          {/* Lead section */}
          <div className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
            <p className="text-base mb-3">
              The <strong>Historic Wingate Track</strong> is a public 320-meter track located in Brooklyn, New York, and the primary physical site of WINGO World. Named after George Wood Wingate, the track functions as a municipal athletic facility and as the sole location where WINGO can be mined.
            </p>
            <p className="text-base mb-3">
              All WINGO issuance is tied to <a href="https://www.strava.com/segments/39307521" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">verified 320-meter segments completed on the track</a>. These activities are recorded on <a href="/" className="text-blue-600 hover:underline">the WINGO World Ledger</a> <a href="/" className="text-blue-600 hover:underline"></a> and overseen by <a href="/wingipedia/daisy" className="text-blue-600 hover:underline">Coach DAISY™</a> of the 320 Track Club.
            </p>
          </div>

        </div>
        </div>
      </div>

      {/* Frozen Contents - Desktop only */}
      <div className="hidden lg:block fixed top-36 left-4 w-44 z-10">
        <div className="bg-white p-3" style={{ fontFamily: 'Georgia, serif' }}>
              <div className="flex justify-between items-center mb-2">
                <h2 className="text-sm font-bold">Contents</h2>
                <button className="text-xs text-blue-600 hover:underline">[hide]</button>
              </div>
              <ol className="list-decimal list-inside space-y-0.5 text-xs">
                <li><a href="#the-divot" className="text-blue-600 hover:underline">The Divot</a></li>
                <li><a href="#wingate-concerts" className="text-blue-600 hover:underline">Wingate Concerts</a></li>
                <li><a href="#references" className="text-blue-600 hover:underline">References</a></li>
                <li><a href="#see-also" className="text-blue-600 hover:underline">See also</a></li>
              </ol>
            </div>
          </div>

      {/* Main content area with proper positioning */}
      <div className="w-full py-1">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 lg:ml-36">
          {/* Main content - sections that wrap around bio image */}
          <div className="lg:mr-0">

            {/* Mobile bio image - appears after table of contents */}
            <div className="block lg:hidden mb-6">
              <div className="bg-white border border-gray-300 p-3 text-xs" style={{ fontSize: '11px', lineHeight: '1.3' }}>
                <div className="text-center mb-2">
                  <span className="font-bold" style={{ fontSize: '14px' }}>Historic Wingate Track</span>
                </div>
                
                <div className="text-center mb-2">
                  <img 
                    src="/wingate1.jpg" 
                    alt="Historic Wingate Track" 
                    className="w-full h-56 object-cover rounded"
                    style={{ objectPosition: 'center' }}
                  />
                </div>
                
                <div className="space-y-0.5">
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Location:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>Brooklyn, NY</span>
                  </div>
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Named for:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>George Wood Wingate</span>
                  </div>
            
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Opened:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>1957<sup><a href="#ref-1" className="text-blue-600 hover:underline" title="Official opening">*</a></sup></span>
                  </div>
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Tenants:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>Brooklyn; 320 Track Club</span>
                  </div>
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Overseer:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>Coach DAISY™</span>
                  </div>
                </div>
              </div>
            </div>

            {/* The Divot section */}
            <section id="the-divot" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>
                <span className="block w-full lg:inline lg:max-w-[calc(100%-350px)]">The Divot</span>
              </h2>
              
              <p className="mb-3 text-base">
                A notable physical feature of the Historic Wingate Track is the divot, a persistent depression in the track surface located approximately 140 meters into the loop on the east side.
              </p>

              <p className="mb-3 text-base">
                The divot is a known surface irregularity that can affect stride and footing, particularly during faster running or crowded sessions. It is widely recognized by regular users of the track and is considered a minor but real injury hazard.
              </p>

            </section>

            {/* Wingate Concerts section */}
            <section id="wingate-concerts" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>
                <span className="block w-full lg:inline lg:max-w-[calc(100%-350px)]">Wingate Concerts</span>
              </h2>
              
              <p className="mb-3 text-base">
                Wingate Park has historically functioned as a major outdoor performance venue, hosting free summer concerts drawing large audiences.
              </p>

              <p className="mb-3 text-base">
                Artists who have performed at Wingate include:
              </p>

              <ul className="list-disc list-inside space-y-1 text-base ml-4 mb-3">
                <li>Chaka Khan</li>
                <li>Lauryn Hill</li>
                <li>Aretha Franklin</li>
                <li>MC Hammer</li>
                <li>Doug E. Fresh</li>
                <li>Slick Rick</li>
                <li>Robin Thicke</li>
                <li>MC Lyte</li>
                <li>The O'Jays</li>
                <li>Sean Paul</li>
                <li>The Mighty Sparrow</li>
              </ul>

              <p className="mb-3 text-base">
                <sup><a href="#ref-2" className="text-blue-600 hover:underline">[2]</a><a href="#ref-3" className="text-blue-600 hover:underline">[3]</a></sup>
              </p>

            </section>

            {/* References section */}
            <section id="references" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>
                <span className="block w-full lg:inline lg:max-w-[calc(100%-350px)]">References</span>
              </h2>
              
              <ol className="list-decimal list-inside space-y-1 text-base ml-4 mb-3">
                <li id="ref-1"><a href="https://www.nycgovparks.org/parks/wingate-park/history" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">NYC Parks – Wingate Park History</a> <span className="text-sm italic text-gray-600">(Official opening: 1957)</span></li>
                <li id="ref-2"><a href="https://archive.nytimes.com/query.nytimes.com/gst/fullpage-9905E6DA1F31F931A3575BC0A96F9C8B63.html" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">New York Times, 1987</a></li>
                <li id="ref-3"><a href="https://www.nytimes.com/2010/07/16/arts/music/16concerts.html" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">New York Times, 2010</a></li>
              </ol>

            </section>


            {/* See also */}
            <section id="see-also" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>See also</h2>
              <ul className="list-disc list-inside space-y-1 text-base">
                <li><a href="/wingipedia/daisy" className="text-blue-600 hover:underline">Coach DAISY™</a></li>
                <li><a href="/wingipedia/wingo" className="text-blue-600 hover:underline">WINGO Currency</a></li>
                <li><a href="/wingipedia/wingo-unit" className="text-blue-600 hover:underline">Wingo</a></li>
              </ul>
            </section>
              </div>
        </div>
      </div>
    </div>
  );
};

export default WingateWiki;

